import { app } from '../../app';

app.run(init);

/** @ngInject */
function init($transitions, $uibModalStack) {
    $transitions.onExit({}, () => {
        while ($uibModalStack.getTop()) {
            $uibModalStack.dismiss($uibModalStack.getTop().key);
        }

        /* todo: delete after all modals are converted to $uibModal */
        $('.sp_modalView').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    });

    /* todo: delete after all modals are converted to $uibModal */
    $(() => {
        $('body').on('hidden.bs.modal', () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        });
    });
}



// WEBPACK FOOTER //
// ./src/portal/init/ui-router/close-modal-on-exit.js